import RecaptchaNotice from './RecaptchaNotice';

export default RecaptchaNotice;
